var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-settings"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    clipPath: "url(#clip-settings)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-settings",
    "data-name": "Icon material-settings",
    d: "M260.8,167.7a116.9,116.9,0,0,0,1.05-14.7,116.9,116.9,0,0,0-1.05-14.7l31.65-24.75a7.568,7.568,0,0,0,1.8-9.6l-30-51.9a7.539,7.539,0,0,0-9.15-3.3l-37.35,15a109.592,109.592,0,0,0-25.35-14.7L186.7,9.3a7.314,7.314,0,0,0-7.35-6.3h-60A7.314,7.314,0,0,0,112,9.3l-5.7,39.75a115.243,115.243,0,0,0-25.35,14.7l-37.35-15a7.317,7.317,0,0,0-9.15,3.3l-30,51.9a7.4,7.4,0,0,0,1.8,9.6L37.9,138.3a118.959,118.959,0,0,0-1.05,14.7,118.959,118.959,0,0,0,1.05,14.7L6.246,192.45a7.568,7.568,0,0,0-1.8,9.6l30,51.9a7.539,7.539,0,0,0,9.15,3.3l37.35-15a109.591,109.591,0,0,0,25.35,14.7L112,296.7a7.314,7.314,0,0,0,7.35,6.3h60a7.314,7.314,0,0,0,7.35-6.3l5.7-39.75a115.243,115.243,0,0,0,25.35-14.7l37.35,15a7.317,7.317,0,0,0,9.15-3.3l30-51.9a7.568,7.568,0,0,0-1.8-9.6L260.8,167.7Zm-111.45,37.8a52.5,52.5,0,1,1,52.5-52.5A52.558,52.558,0,0,1,149.346,205.5Z",
    transform: "translate(0.687 -3)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.4c58a2635be831c8eed3cd7a2b11a11a.svg";
export { ForwardRef as ReactComponent };